'use strict';

import {getToken, isTokenExpired} from './session'
import Settings from './settings'

    /*ready: function() {
      if(!window.fetch) {
      var e = document.createElement('script');
      e.src = '../../bower_components/fetch/fetch.js';
      document.head.appendChild(e);
      } 
    },*/
    function handleErrors (response) {
        if (!response.ok) { throw Error(response.statusText.substr(6)); }
        return response;
    }
    function parseJSON (response) {
            return response.json();
    }
    export default function RPC (param, auth) {
             let httpHeaders = new Headers();
        httpHeaders.append('Content-Type', 'application/json');
        httpHeaders.append('Accept', 'application/json');
        if (auth && !isTokenExpired()) {
            httpHeaders.append('Authorization', 'Bearer ' + getToken());
        }
         return fetch(Settings.serverUrl + 'actions', {
            method: 'POST',
            headers: httpHeaders,
            body: JSON.stringify(param)
        })
            .then(handleErrors)
            .then(parseJSON);
    }



// WEBPACK FOOTER //
// ./src/modules/server.js